import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import RetroLoveSnake from './RetroLoveSnake';
import LoveWordle from './LoveWordle';
import '../styles/MiniGamesModal.css';

const MiniGamesModal = ({ onClose, initialTab = 'wordle' }) => {
  const [activeTab, setActiveTab] = useState(initialTab); // 'wordle' or 'snake'

  // Manage modal open state on body
  useEffect(() => {
    document.body.classList.add('mini-games-open');
    return () => {
      document.body.classList.remove('mini-games-open');
    };
  }, []);

  // Close on Escape key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  return (
    <div
      className="mini-games-backdrop"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="mini-games-modal" role="dialog" aria-modal="true" aria-label="Mini Oyunlar">
        {/* Modal Top Bar */}
        <div className="mini-games-header">
          <div className="mini-games-tabs" role="tablist">
            <button
              role="tab"
              aria-selected={activeTab === 'wordle'}
              className={`mini-tab-btn ${activeTab === 'wordle' ? 'active' : ''}`}
              onClick={() => setActiveTab('wordle')}
            >
              <span className="tab-icon">🔤</span> Wordle (3-10 Harf)
            </button>
            <button
              role="tab"
              aria-selected={activeTab === 'snake'}
              className={`mini-tab-btn ${activeTab === 'snake' ? 'active' : ''}`}
              onClick={() => setActiveTab('snake')}
            >
              <span className="tab-icon">🐍</span> Yılan Oyunu
            </button>
          </div>

          <button
            onClick={onClose}
            className="mini-games-close-btn"
            aria-label="Kapat"
            title="Kapat"
          >
            <X size={20} />
          </button>
        </div>

        {/* Modal Content */}
        <div className="mini-games-body">
          {activeTab === 'wordle' && <LoveWordle />}
          {activeTab === 'snake' && <RetroLoveSnake />}
        </div>
      </div>
    </div>
  );
};

export default MiniGamesModal;

